import { useCallback, useEffect, useState } from 'react';

import { useKnockTokenMutation } from '@/generated';
import { Nullable } from '@/utils/globalTypes';

export const useKnockToken = (options?: Record<'enable', boolean>) => {
  const { enable = false } = options ?? {};

  const [knockToken, setKnockToken] = useState<Nullable<string>>(null);
  const [knockTokenMutation] = useKnockTokenMutation();

  const shouldRequestOnLoad = !knockToken && enable;

  const getKnockToken = useCallback(async () => {
    knockTokenMutation({
      onCompleted: ({ knockToken }) => {
        if (!knockToken) return;

        setKnockToken(knockToken.token);
      },
    });
  }, [knockTokenMutation]);

  useEffect(() => {
    if (!shouldRequestOnLoad) return;

    getKnockToken();
  }, [shouldRequestOnLoad, getKnockToken]);

  return {
    knockToken,
    refreshKnockToken: getKnockToken,
  };
};
